function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.06 18.52c-.73 3.85-1.63 7.55-4.3 9.48-.8-5.83 1.2-10.2 2.16-14.85-1.6-2.7.2-8.13 3.57-6.8C17.6 8 9.9 16.4 15.1 17.45c5.45 1.1 7.67-9.44 4.3-12.87C14.52-.4 5.2 4.45 6.34 11.54c.28 1.73 2.07 2.26.7 4.65C3.94 15.5 3 13 3.12 9.7 3.32 4.38 7.95.6 12.6.1 18.48-.58 24 2.24 24.76 7.77c.86 6.25-2.65 13-8.94 12.52-1.7-.18-2.42-1-3.76-1.8z",
  className: ""
});

var SvgPinterest = function SvgPinterest(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinterest, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pinterest.d1243115.svg";
export { ForwardRef as ReactComponent };